import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
} from "@/comn/hooks";
import {
    APIS,
    SF_APP_DTL_INSC_INFO,
    SF_APP_RGST_INSC_RSLT,
    SG_APP_RGST_INSC_ATCM,
} from "@/tz/go/egaz/osci/lpco/app/service/OsciLpcoAprvService";
import { OgaAprvRqst } from "@/comn/comn/aprv/OgaAprvRqst";
import { SF_APRV_RQST } from "@/comn/comn/aprv/service/AprvService";

/**
 * LPCO Application Inspection Result
 * !== LPCO 신청서 검사 결과 ==!
 */
export const OSCI0201011S = (props: any) => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0007"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    const { close, postMessage, getParams } = usePopup();
    const params = getParams(); // 부모창에서 전달된 Parameter

    let errmsg: any;

    const [atcmList, setAtcmList] = useState(comnUtils.getGridData([]));
    const [atcmVisible, setAtcmVisible] = useState(false);
    const [sbmtVisible, setSbmtVisible] = useState(false);
    const [aprvExisYn, setAprvExisYn] = useState("N");
    const [aprvTargetStat, setAprvTargetStat] = useState<string[]>([]);

    const [excludeAuditCode, setExcludeAuditCode] = useState<any[]>(["VF", "FV", "AP", "RS"]);

    /*
     * Code Resource
     * !== 사용할 Code 정의 ==!
     */
    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0131" },
            { area: "comnCd", comnCd: "OSC0025" },
        ],
    });

    const form = {
        appDtlInscInfo: useForm({
            defaultSchema: SF_APP_DTL_INSC_INFO,
        }),
        appRgstInscRslt: useForm({
            defaultSchema: SF_APP_RGST_INSC_RSLT,
        }),
        aprvRqstForm: useForm({
            defaultSchema: SF_APRV_RQST,
            defaultValues: {
                ptlTpCd: "O",
                bsopClsfCd: "OSC",
                scrnDocCd: "scrn_osca0004", // Approval review screen 029Q !== 결재 검토화면 029Q ==!
                aprvReffId: "/" + params.appInfo.appId,
                docNo: params.appInfo.appNo, // Application number as document number !== 문서 번호로 신청서 번호 사용 ==!
                aprvAfPrcssCfgnId: "cfgn_osc0009", // 결재완료 후처리 ID (신규 검사)
                cnclAfPrcssCfgnId: "cfgn_osc0011", // 결재취소 후처리 ID
                rtrnAfPrcssCfgnId: "cfgn_osc0012", // 반려 후처리 ID
                prevStageRtrnUseYn: "Y",
                itsfAprvYn: "N",
                rjctStatUseYn: "N", // 거절 상태 사용 안 함
                grpAprvYn: "N",
            },
        }),
    };

    /*
     * Register Inspection Result Attachment Files Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Attachment Files List !== 첨부문서 목록 ==!
        appRgstInscAtcm: useGrid({
            defaultSchema: SG_APP_RGST_INSC_ATCM,
            // page: pgeStore?.page,
            // size: pgeStore?.size,
        }),
    };

    /*
     * Application Item Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Application Information !== 신청서 정보 조회 ==!.
        getAppAprvInfo: useFetch({
            api: (data) => APIS.getAppAprvInfo({ reffId: data.appId }),
            onSuccess: (data) => {
                if (data.appAprvInfo!) {
                    form.appRgstInscRslt.setValues(data.appAprvInfo.content);

                    if ("RE" == data.appAprvInfo.content.prcssStatCd || "RJ" == data.appAprvInfo.content.prcssStatCd) {
                        setAtcmVisible(false);
                    } else {
                        // if (data.appAprvInfo.content.prcssStatCd) {
                        handler.getInscAtcmList();
                        // }
                    }

                    if (data.appAprvInfo.content.prcssStatCd!) {
                        setSbmtVisible(true);
                    }

                    // Set previous approval ID !== 기존 결재 ID 설정 ==!
                    if (data?.appAprvInfo?.content?.aprvId) {
                        form.aprvRqstForm.setValue("aprvId", data?.appAprvInfo?.content?.aprvId);
                    }
                }

                // Check approval existence !== 승인 존재 여부 설정 ==!
                const aprvExisYn = data?.prcsInfo?.content?.aprvExisYn || "N";
                setAprvExisYn(aprvExisYn);

                // Approval-gating target result states, from backend !== 전자결재 대상 결과 상태집합(백엔드 수신) ==!
                setAprvTargetStat(data?.prcsInfo?.content?.aprvTargetStatList || []);

                const nregYn = data?.appAprvInfo?.content?.nregYn || "";
                const prcsRoleTpCd = data?.prcsInfo?.content?.prcsRoleTpCd || "";
                const prevPrcsRoleTpCd = data?.prcsInfo?.content?.prevPrcsRoleTpCd || "";
                if (nregYn === "Y") {
                    setExcludeAuditCode(APIS.getExcludeAuditRsltCdList("NR", prevPrcsRoleTpCd));
                } else {
                    setExcludeAuditCode(APIS.getExcludeAuditRsltCdList(prcsRoleTpCd, prevPrcsRoleTpCd));
                }
            },
            onError: (error) => {
                errmsg = error.response.data.errorCode == -1 ? "msg.osc.00015" : error.response.data.errorMessage;

                modal.openModal({
                    content: errmsg,
                });
            },
        }),
        getInscAtcmList: useFetch({
            api: (page = grid.appRgstInscAtcm.page) => {
                return APIS.getInscAtcmList({ ...params.appInfo }, page, grid.appRgstInscAtcm.size);
            },
            key: [grid.appRgstInscAtcm.page, grid.appRgstInscAtcm.size],
            onSuccess: (data) => {
                if (data.atcmList.content! && data.atcmList.content.length > 0) {
                    setAtcmList(comnUtils.getGridData(data.atcmList.content || []));
                    setAtcmVisible(true);
                } else {
                    if ("IP" == form.appRgstInscRslt.getValue("prcssStatCd")) {
                        setAtcmList(comnUtils.getGridData([]));
                        setAtcmVisible(true);
                    }
                }
            },
            onError: () => {},
            showToast: false,
        }),
        saveAppAprvRslt: useFetch({
            api: (data) => {
                return APIS.saveAppAprvRslt({ ...data });
            },
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00006",
                    onConfirm: () => {
                        if ("RE" == data.osceComnAsnmtRDto.content.prcssStatCd) {
                            setAtcmList(comnUtils.getGridData([]));
                        }
                        handler.setInit();
                    },
                    onClose: () => {
                        if ("RE" == data.osceComnAsnmtRDto.content.prcssStatCd) {
                            setAtcmList(comnUtils.getGridData([]));
                        }
                        handler.setInit();
                    },
                });
            },
            onError: (error) => {
                const errmsg = error.response.data.errorCode == -1 ? "msg.osc.00015" : error.response.data.errorMessage;

                modal.openModal({
                    content: errmsg,
                });
            },
        }),
        sbmtAppAprvRslt: useFetch({
            api: (data) => {
                return APIS.sbmtAppAprvRslt({ ...data });
            },
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00006",
                    onConfirm: () => {
                        modal.postMessage({ rslt: "sbmt" });
                    },
                    onClose: () => {
                        modal.postMessage({ rslt: "sbmt" });
                    },
                });
            },
            onError: (error) => {
                const errmsg = error.response.data.errorCode == -1 ? "msg.osc.00015" : error.response.data.errorMessage;

                modal.openModal({
                    content: errmsg,
                });
            },
        }),
        // Save Inspection Result Approval Request !== 검사 결과 결재 요청 등록 ==!
        rqstAprvRslt: useFetch({
            api: (data) => {
                return APIS.rqstAprvRslt({ ...data });
            },
            onSuccess: (data) => {
                // Close the approval popup only on success; on failure it stays open !== 결재 팝업은 성공 시에만 닫고 실패 시 유지 ==!
                modal.closeModal("OgaAprvRqst");
                modal.openModal({
                    content: "msg.osc.00006",
                    onConfirm: () => {
                        modal.postMessage({ rslt: "sbmt" });
                    },
                    onClose: () => {
                        modal.postMessage({ rslt: "sbmt" });
                    },
                });
            },
            onError: (error) => {
                // No response (network error, server restart) also shows the default error !== 응답이 없는 경우(네트워크 오류, 서버 재기동)도 기본 오류 메시지 표시 ==!
                const errmsg =
                    !error.response?.data?.errorMessage || error.response.data.errorCode == -1
                        ? "msg.osc.00015"
                        : error.response.data.errorMessage;

                modal.openModal({
                    content: errmsg,
                });
            },
        }),
    };

    /*
     * Register Inspection Result Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        setInit: async () => {
            await form.appDtlInscInfo.setValues(params.appInfo);
            await handler.getAppAprvInfo();
        },
        getAppAprvInfo: async () => {
            fetch.getAppAprvInfo.fetch(params.appInfo);
        },
        // Get Application Inspection Attachment List !== 신청서 검사 첨부파일 목록 조회 ==!
        getInscAtcmList: (page: number = 0) => {
            grid.appRgstInscAtcm.setPage(page);
            fetch.getInscAtcmList.fetch(page);
        },
        // Registration validation of application inspection results !== 신청서 검사결과 등록 유효성 검사 ==!
        validateRgstInscRslt: async (type: any) => {
            let chkRslt = await form.appRgstInscRslt.validate();

            const inscAtcmList = grid.appRgstInscAtcm.getData();
            const prcssStatCd = form.appRgstInscRslt.getValue("prcssStatCd");
            if (prcssStatCd != "RE") {
                if (chkRslt) {
                    // if (inscAtcmList.length == 0) {
                    //     modal.openModal({
                    //         content: "msg.osc.00085",
                    //     });
                    //     return;
                    // } else {
                    try {
                        inscAtcmList.map((item: any) => {
                            if (!item.atchFile || !item.atcmTpCd) {
                                throw false;
                            }
                        });
                    } catch (error) {
                        if (error == false) {
                            modal.openModal({
                                content: "msg.osc.00102",
                            });
                            return;
                        }
                    }
                    // }
                }
            }

            // const data = {
            //     form.appRgstInscRslt.getValues(),
            //     esweComnInscRsltReqDto: {
            //         esweComnAsnmtRDto: { ...form.appRgstInscRslt.getValues() },
            //         esweComnInscAtcmDtoList: inscAtcmList,
            //     },
            // };

            const data = {
                ...form.appRgstInscRslt.getValues(),
                osceComnInscRsltReqDto: {
                    osceComnAsnmtRDto: { ...form.appRgstInscRslt.getValues() },
                    osceComnInscAtcmDtoList: inscAtcmList,
                },
            };

            if (chkRslt) {
                if (type == "save") {
                    modal.openModal({
                        content: "msg.osc.00090",
                        onConfirm: () => {
                            data.osceComnInscRsltReqDto.osceComnAsnmtRDto.reffId = params.appInfo.appId;
                            fetch.saveAppAprvRslt.fetch(data);
                        },
                    });
                } else if (type == "sbmt") {
                    modal.openModal({
                        content: "msg.osc.00092",
                        onConfirm: () => {
                            data.osceComnInscRsltReqDto.osceComnAsnmtRDto.reffId = params.appInfo.appId;
                            // Check approval existence and processing status !== 결재를 해야하고 대상 결과 상태일 경우 결재 팝업 표시 ==!
                            if (aprvExisYn == "Y" && aprvTargetStat.includes(prcssStatCd)) {
                                handler.openAprvRqstPopup(data);
                                return;
                            }
                            fetch.sbmtAppAprvRslt.fetch(data);
                        },
                    });
                }
            }
        },
        click_Btn_AddGridList: () => {
            grid.appRgstInscAtcm.addRow();
        },
        click_Btn_DeleteGridList: () => {
            const seltList: any[] = grid.appRgstInscAtcm.getChecked() || [];
            if (comnUtils.isEmpty(seltList)) {
                modal.openModal({ content: "msg.osc.00009" });
                return;
            }

            grid.appRgstInscAtcm.deleteRow("checkbox");
        },

        // Open Approval Request Popup !== 결재 요청 팝업 오픈 ==!
        openAprvRqstPopup: (data: any) => {
            modal.openModal({
                content: (
                    <OgaAprvRqst
                        paramData={{
                            bsopClsfCd: "OSC",
                            scrnDocCd: "scrn_osca0004",
                            aprvId: form.aprvRqstForm.getValue("aprvId"),
                        }}
                        callbackFn={(aprvData: any) => {
                            if (aprvData) {
                                form.aprvRqstForm.setValues({
                                    aprvRqstTtleNm: aprvData.aprvRqstTtleNm,
                                    aprvRqstCn: aprvData.aprvRqstCn,
                                    usrDmnId: aprvData.usrDmnId,
                                    aprvPrcssPathMgmtId: aprvData.aprvPrcssPathMgmtId,
                                });
                                const param = {
                                    ...data,
                                    aprvRqstDto: form.aprvRqstForm.getValues(),
                                };
                                // Return the request so the popup can disable its button; popup is closed in onSuccess !== 팝업 버튼 비활성을 위해 요청을 반환, 팝업은 onSuccess에서 닫음 ==!
                                return fetch.rqstAprvRslt.fetch(param);
                            }
                            modal.closeModal("OgaAprvRqst");
                        }}
                    />
                ),
                size: "md",
                draggable: true,
                close: false,
                id: "OgaAprvRqst",
            });
        },
    };

    useEffect(() => {
        handler.setInit();
    }, []);

    const render = {
        grid_appInscAtcmLst: {
            head: {},
            cell: {
                atcdFile: (props: any) => {
                    const { binding, rowValues, value } = props;
                    const atcmId = rowValues.atcmId;
                    //rowValues.atcdFile = !rowValues.atcdFile ? rowValues.atcdFileGrpId : rowValues.atcdFile;
                    return (
                        <>
                            {atcmId && (
                                <FormControl type="file" bsopClsfCd="OSC" required={true} value={rowValues.atcdFile} />
                            )}
                        </>
                    );
                },
            },
            edit: {
                atcdFile: (props: any) => {
                    const { binding, rowValues, value } = props;
                    const atcmId = rowValues.atcmId;
                    //rowValues.atcdFile = !rowValues.atcdFile ? rowValues.atcdFileGrpId : rowValues.atcdFile;
                    return (
                        <>
                            {atcmId && (
                                <FormControl type="file" bsopClsfCd="OSC" required={true} value={rowValues.atcdFile} />
                            )}
                        </>
                    );
                },
            },
            checkbox: (row: any) => {
                // row : 해당 row 의 데이터(rowValues)
                // return 값이 true 이면 checkbox enabled (선택가능);
                // return 값이 false 이면 checkbox disabled (선택불가능);
                return true; // row 데이터에 의한 제어 : row  데이터의 mrn 값이 12345 이면 checkbox enabled(선택가능)
            },
        },
    };

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Layout direction="col">
                        <Layout>
                            <Layout.Left>
                                <Group.Title title={"T_INSC_RSLT"} titleSize={1}></Group.Title>
                            </Layout.Left>
                        </Layout>

                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.appDtlInscInfo.schema.appNo} />
                                <Group.Control {...form.appDtlInscInfo.schema.ucrNo} />
                            </Group.Row>

                            <Group.Row>
                                <Group.Control {...form.appDtlInscInfo.schema.appNm} />
                                <Group.Control {...form.appDtlInscInfo.schema.sbmtDtm} />
                            </Group.Row>

                            <Group.Row>
                                <Group.Control
                                    {...form.appRgstInscRslt.schema.prcssStatCd}
                                    controlSize={10}
                                    onChange={(value) => {
                                        if (value == "RE" || value == "RJ" || value == "NR") {
                                            setAtcmVisible(false);
                                        } else {
                                            setAtcmVisible(true);
                                        }
                                    }}
                                    excludes={excludeAuditCode}
                                />
                            </Group.Row>

                            <Group.Row>
                                <Group.Control {...form.appRgstInscRslt.schema.prcssRsnCn} controlSize={10} />
                            </Group.Row>

                            <Group.Row>
                                <Group.Control {...form.appRgstInscRslt.schema.rmrk} controlSize={10} />
                            </Group.Row>
                        </Group.Section>
                    </Layout>
                    <Layout direction="row">
                        <Layout.Right>
                            <Button
                                role="save"
                                onClick={() => {
                                    handler.validateRgstInscRslt("save");
                                }}
                            />
                            {sbmtVisible && (
                                <Button
                                    role="submit"
                                    onClick={() => {
                                        handler.validateRgstInscRslt("sbmt");
                                    }}
                                >
                                    {t("L_CFRM")}
                                </Button>
                            )}
                        </Layout.Right>
                    </Layout>
                    {atcmVisible && (
                        <Layout direction="col">
                            <Layout>
                                <Group.Title title={"T_ATCM"} titleSize={2}></Group.Title>
                                <Layout direction="row">
                                    <Layout.Left></Layout.Left>
                                    <Layout.Right>
                                        <Button
                                            role="gridAdd"
                                            onClick={() => {
                                                handler.click_Btn_AddGridList();
                                            }}
                                        ></Button>
                                        <Button
                                            role="gridDelete"
                                            onClick={() => {
                                                handler.click_Btn_DeleteGridList();
                                            }}
                                        ></Button>
                                    </Layout.Right>
                                </Layout>
                            </Layout>
                            <Group>
                                <Group.Body>
                                    <Grid
                                        {...grid.appRgstInscAtcm.grid}
                                        data={atcmList}
                                        render={render.grid_appInscAtcmLst}
                                    />
                                </Group.Body>
                            </Group>
                        </Layout>
                    )}
                </Group.Body>
            </Group>
        </Page>
    );
};
